import { registerComponent } from 'lib/react_on_rails';

import FlashRenderer from './flash_renderer';

registerComponent('FlashRenderer', FlashRenderer);
